import {AuthType, AuthTypeEnum, BaseAuthenticationMethod} from './base-authentication-method';

export class AmDocumentTemplate extends BaseAuthenticationMethod {
    type = 'documenttemplate';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
